// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1300":"9ecf85ae","8068":"64987e36"}[chunkId] + ".chunk.css";
};